export const PASS_KEY = process.env.PASS_KEY;
export const TOKEN_NAME = process.env.LOCAL_STORAGE_TOKEN_NAME;
export const API_URL = process.env.API_URL;
export const ROLLBAR_TOKEN = process.env.ROLLBAR_TOKEN;
export const PARTNER = process.env.PARTNER;
export const STRAPI_URL = process.env.STRAPI_URL;
